var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8335 7.33398C15.8335 10.6477 13.1472 13.334 9.83347 13.334C9.77614 13.334 9.71901 13.3332 9.66207 13.3316V13.334H0.747803V11.9626H6.01532C4.68275 10.8621 3.83347 9.1972 3.83347 7.33398C3.83347 4.02027 6.51976 1.33398 9.83347 1.33398C13.1472 1.33398 15.8335 4.02027 15.8335 7.33398ZM9.83345 10.334C11.4903 10.334 12.8335 8.99084 12.8335 7.33398C12.8335 5.67713 11.4903 4.33398 9.83345 4.33398C8.1766 4.33398 6.83345 5.67713 6.83345 7.33398C6.83345 8.99084 8.1766 10.334 9.83345 10.334Z",
    fill: "#009FDF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductActive);
export default __webpack_public_path__ + "static/media/product-active.a53412659e5625da78d73eb85632c1eb.svg";
export { ForwardRef as ReactComponent };